import { render } from "./Social.vue?vue&type=template&id=6784c2e4&ts=true"
import script from "./Social.vue?vue&type=script&lang=ts"
export * from "./Social.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__